import styled from 'styled-components';
import { colors } from '../GlobalStyles';
import heroImage from '../assets/consulting-image-1920w.jpeg';

const HeroContainer = styled.section`
  position: relative;
  height: 100vh;
  background: linear-gradient(rgba(26, 12, 6, 0.7), rgba(26, 12, 6, 0.7)),
    url(${heroImage}) center/cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${colors.white};
`;

const HeroContent = styled.div`
  max-width: 800px;
  padding: 2rem;
  z-index: 2;
`;

const MainHeading = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  color: ${colors.accentOrange};
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
    letter-spacing: 1px;
  }
`;

const SubHeading = styled.h2`
  font-size: 1.5rem;
  font-weight: 300;
  color: ${colors.white};
  margin-bottom: 2.5rem;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const PrimaryButton = styled.button`
  background: ${colors.accentOrange};
  color: ${colors.white};
  border: 2px solid ${colors.accentOrange};
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e6951f;
    border-color: #e6951f;
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    width: 200px;
  }
`;

const SecondaryButton = styled.button`
  background: transparent;
  color: ${colors.white};
  border: 2px solid ${colors.white};
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${colors.white};
    color: ${colors.primaryDark};
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    width: 200px;
  }
`;

export function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactClick = () => {
    scrollToSection('contact-section');
  };

  return (
    <HeroContainer>
      <HeroContent>
        <MainHeading>Smart Solutions</MainHeading>
        <SubHeading>
          Innovative IT consultancy specializing in scalable microservices, cloud architecture, and
          cutting-edge technology solutions.
        </SubHeading>
        <ButtonContainer>
          <SecondaryButton onClick={() => scrollToSection('services')}>
            Our Services
          </SecondaryButton>
          <PrimaryButton onClick={handleContactClick}>Contact Us</PrimaryButton>
        </ButtonContainer>
      </HeroContent>
    </HeroContainer>
  );
}
